import { Method } from 'axios';
import instance from './instance';

const request = async (
  url: string,
  method: Method,
  headers = {},
  jsonData: any
) => {
  if (method === 'get') {
    try {
      const { data } = await instance({
        method: method,
        url: url,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        params: jsonData,
      });

      return data;
    } catch (error) {
      await Promise.reject(error);
    }
  } else {
    try {
      const data = await instance({
        method: method,
        url: url,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        data: jsonData,
      });
      return data;
    } catch (error) {
      await Promise.reject(error);
    }
  }
};

export default request;
